import setupAxios from '../../lib/redux/setupAxios'

export const getAllIncidents = async (queryParams) => {
    return setupAxios
        .get(`/incidents?order=desc`, {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const getAllFilteredIncidents = async (payload) => {
    return setupAxios
        .post(`/incidents/filter`, payload)
        .then((res) => res?.data?.data)
}

export const getFilteredIncidentsWithEvents = async (payload) => {
    return setupAxios
        .post(`/incidents/filter_with_events`, payload)
        .then((res) => res?.data?.data)
}

export const getIncidentById = async (id) => {
    return setupAxios.get(`/incidents/${id}`).then((res) => res?.data?.data)
}

export const getAllCombineIncidents = async ({ id, queryParams }) => {
    return setupAxios
        .get(`incidents/get_incendents_to_combine/${id}`, {
            params: queryParams,
        })
        .then((res) => res?.data?.data)
}

export const combinceIncidentsByID = async ({ id, payload }) => {
    return setupAxios
        .post(`/incidents/combine_incidents/${id}`, payload)
        .then((res) => res?.data)
}

export const incidentAdjustScore = async ({ id, payload }) => {
    return setupAxios
        .post(`/incidents/adjust_score/${id}`, payload)
        .then((res) => res?.data)
}

export const updateIncidentStatusByID = async ({ id, payload }) => {
    return setupAxios.post(`/incidents/${id}`, payload).then((res) => res?.data)
}

export const getIncidentCommentsById = async ({ incident_id, sort, order, pagination }) => {
    const queryParams = new URLSearchParams();

    if (sort) queryParams.append('sort', sort);
    if (order) queryParams.append('order', order);
    if (pagination) queryParams.append('pagination', pagination);

    const url = queryParams.toString()
        ? `/incidents/get_incident_comments/${incident_id}?${queryParams.toString()}`
        : `/incidents/get_incident_comments/${incident_id}`;

    const res = await setupAxios.get(url);
    return res?.data?.data;
};
export const addCommentToIncident = async (id, payload) => {
    return setupAxios.post(`/incidents/add_comment/${id}`, payload)
      .then(res => res?.data)
  }
  

export const updateCloseMutipleIncidents = async (payload) => {
    return setupAxios
        .put(`incidents/close_multiple_incidents`, payload)
        .then((res) => res?.data?.data)
}
